import axios from 'axios';

// Use relative path for API calls (works with Nginx proxy)
// In development, REACT_APP_API_URL can be set to http://localhost:8000
// In production, use relative path /api which will be proxied by Nginx
const API_URL = process.env.REACT_APP_API_URL || '/api';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      // Only redirect if we're not already on the login page
      // This prevents redirect loops and allows error messages to be displayed
      const currentPath = window.location.pathname;
      if (currentPath !== '/login' && !currentPath.startsWith('/login')) {
        // Clear tokens
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        // Only redirect if we're not in the middle of authentication
        // Let PrivateRoute handle the redirect to avoid loops
        if (!error.config?.url?.includes('/auth/me')) {
          // For non-auth endpoints, redirect immediately
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
